export const locale = {
  lang: 'en',
  data: {
    MENU: {
      HOME: 'Upload',
      SAMPLE: 'Geocode',
      PROFILE: 'Profile',
      HISTORY: 'History'
    }
  }
}
